import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

/**
 * This component creates input with type: text, email or password.
 */

class InputText extends React.Component {
    handleFocus = (event) => {
        // When input on focus, the value is selected.
        event.target.select();
        if (typeof this.props.onFocus === 'function') {
            this.props.onFocus();
        }
    }
    // TODO. Use ARIA instead the error on the class.
    // TODO. validation of the fields.
    render () {
        const { mandatory, type, ...inputProps } = this.props;
        return <input
            { ...inputProps }
            type={ type }
            required={ (mandatory ? 'required' : '') }
            onFocus={ this.handleFocus } />
    }
}

InputText.defaultProps = {
    'type': 'text'
};

InputText.propTypes = {
    'mandatory': PropTypes.bool,
    'onFocus': PropTypes.func,
    'type': PropTypes.string
};

export default InputText;



// WEBPACK FOOTER //
// ./src/components/gdc-components-atoms-input-text/index.jsx